import React, { useEffect, useState } from 'react';
import { Form, Modal, Tab, Tabs } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

import SaveButton from 'components/CustomButtons/SaveButton';
import CloseButton from 'components/CustomButtons/CloseButton';
import { previousModalPage } from 'actions/modalPage';
import { setReturnReason } from 'actions/ShoppingCart';
import useProducts from 'utils/hooks/useProducts';
import { getProductInOrderByIndex } from 'reducers/ShoppingCart';

import * as styles from './ProductReturnReasons.css';

const ProductReturnReasons = ({ reasons, order, resolve, reject }) => {
  const { t } = useTranslation('return');
  const {
    products: [originalProduct],
    loading,
  } = useProducts({ productID: order.productID });
  const dispatch = useDispatch();
  const cartOrder = useSelector(getProductInOrderByIndex(order.orderIndex));

  const orderMissing = (!loading && !originalProduct) || !cartOrder;
  useEffect(() => {
    if (orderMissing) {
      reject(new Error(i18next.t('alerts:cartRowRemovedWhileUpdatingQty')));
      dispatch(previousModalPage());
    }
  }, [dispatch, orderMissing, reject]);

  const [key, setKey] = useState('perItem');
  const [selectedReason, setSelectedReason] = useState('');

  const reasonNames = reasons.map(reason => reason.name);

  const onChange = e => {
    setSelectedReason(e.target.value);
  };

  useEffect(() => {
    if (reasons.length === 1) {
      Promise.all([
        dispatch(setReturnReason(reasons[0], order.orderIndex)),
        dispatch(previousModalPage()),
      ]).then(() => resolve(reasons[0]));
    }
  }, [dispatch, order.orderIndex, reasons, resolve]);
  return (
    <div
      data-testid="product-return-reasons"
      className={styles['product-return-reasons']}
    >
      <Modal.Header>
        <Modal.Title data-testid="title">
          {t('title')} - {order.name}
        </Modal.Title>
        <div className="d-flex justify-content-end align-items-center">
          <SaveButton
            data-testid="save"
            title={t('common:save', { context: 'changes' })}
            disabled={!selectedReason}
            action={async () => {
              const reason = reasons.find(
                reason => reason.name === selectedReason,
              );

              if (key === 'perSale') {
                Promise.all([
                  dispatch(setReturnReason(reason)),
                  dispatch(previousModalPage()),
                ]).then(() => resolve(reason));
                return;
              }

              Promise.all([
                dispatch(setReturnReason(reason, order.orderIndex)),
                dispatch(previousModalPage()),
              ]).then(() => resolve(reason));
            }}
          />
          <CloseButton
            data-testid="close"
            action={() => {
              dispatch(previousModalPage());
              reject(new Error('User cancelled return reason selection'));
            }}
          />
        </div>
      </Modal.Header>
      <Modal.Body>
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={k => setKey(k)}
        >
          <Tab eventKey="perItem" title="Per item">
            <Form.Control
              data-testid="per-item"
              className="mt-3"
              onChange={onChange}
              as="select"
            >
              <option selected disabled>
                Choose
              </option>

              {reasonNames.map(name => (
                <option data-testid="option" data-test-key={name} key={name}>
                  {name}
                </option>
              ))}
            </Form.Control>
          </Tab>
          <Tab eventKey="perSale" title="Per sale">
            <Form.Control
              data-testid="per-sale"
              className="mt-3"
              onChange={onChange}
              as="select"
            >
              <option selected disabled>
                Choose
              </option>
              {reasonNames.map(name => (
                <option data-test-id="option" data-test-key={name} key={name}>
                  {name}
                </option>
              ))}
            </Form.Control>
          </Tab>
        </Tabs>
      </Modal.Body>
    </div>
  );
};
export default ProductReturnReasons;
